export const actionTypes = {
    FETCH_FILTERED_CARDS_COMPLETED: 'FETCH_FILTERED_CARDS_COMPLETED',
    FETCH_CARD_COMPLETED: 'FETCH_CARD_COMPLETED',
    UPDATE_CARD_SEARCH_TERMS: 'UPDATE_CARD_SEARCH_TERMS',
    FETCH_FILTERED_SETS_COMPLETED: 'FETCH_FILTERED_SETS_COMPLETED',
    FETCH_CARD_SYMBOLS_COMPLETED: 'FETCH_CARD_SYMBOLS_COMPLETED',
    ADD_CARD_TO_DECK: 'ADD_CARD_TO_DECK',
    REMOVE_CARD_FROM_DECK: 'REMOVE_CARD_FROM_DECK',
    FETCH_ALL_CARDS_FOR_SET: 'FETCH_ALL_CARDS_FOR_SET'
  };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/constants/actionTypes.ts